import React from 'react';
import { gql } from '@apollo/client';
import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  TopToolbar,
  useRecordContext,
  BooleanField,
} from 'react-admin';
import IdField from 'components/IdField';
import LinkField from 'components/LinkField';
import ActionButton from 'components/ActionButton';
import TimestampFields from 'components/TimestampFields';

const ScreeningActions = () => {
  const record = useRecordContext<any>();
  if (!record) {
    return null;
  }
  return (
    <TopToolbar>
      {!record.no_show && (
        <ActionButton
          text="Mark as No Show"
          method="PATCH"
          data={{ no_show: true }}
          url={`/v3/admin/professional_screenings/${record.id}`}
        />
      )}
    </TopToolbar>
  );
};

const ProfessionalScreeningShow = () => (
  <Show actions={<ScreeningActions />} data-testid="professional-screening-show">
    <SimpleShowLayout>
      <IdField label="ID" />
      <LinkField label="Professional Id" source="professional_id" />
      <LinkField label="Screener" source="screener_account_id" />
      <DateField
        label="Scheduled Time"
        source="scheduled_time"
        showTime
        options={{ hour12: false }}
      />
      <DateField label="Canceled At" source="canceled_at" showTime options={{ hour12: false }} />
      <BooleanField label="No Show" source="no_show" />
      <TextField label="Reason" source="reason" />
      <TextField label="Type" source="screening_type" />
      <TextField label="Calendly Event Uuid" source="calendly_event_uuid" />
      <TextField label="Calendly Invitee Uuid" source="calendly_invitee_uuid" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

ProfessionalScreeningShow.query = gql`
  query GET_ONE($id: Int!) {
    professionalScreening(id: $id) {
      id
      professional_id
      screener_account_id
      scheduled_time
      calendly_event_uuid
      calendly_invitee_uuid
      reason
      screening_type
      canceled_at
      no_show
      created_at
      updated_at
    }
  }
`;

export default ProfessionalScreeningShow;
